import { CategoryIdEnum, ManufacturerEnum, PjCategoryIdEnum } from '~/types/searchTypes'
import Apple from '~/assets/images/brand-logos/apple.png'
import Asus from '~/assets/images/brand-logos/asus.png'
import Bananarepublic from '~/assets/images/brand-logos/bananarepublic.png'
import Calvinklein from '~/assets/images/brand-logos/calvinklein.png'
import Coach from '~/assets/images/brand-logos/coach.png'
import Columbia from '~/assets/images/brand-logos/columbia.png'
import Crest from '~/assets/images/brand-logos/crest.png'
import Dell from '~/assets/images/brand-logos/dell.png'
import Dkny from '~/assets/images/brand-logos/dkny.png'
import Jbl from '~/assets/images/brand-logos/jbl.png'
import Karllagerfeld from '~/assets/images/brand-logos/karllagerfeld.png'
import EsteeLauder from '~/assets/images/brand-logos/esteelauder.png'
import Lenovo from '~/assets/images/brand-logos/lenovo.png'
import Michaelkors from '~/assets/images/brand-logos/michaelkors.png'
import Msi from '~/assets/images/brand-logos/msi.png'
import Newbalance from '~/assets/images/brand-logos/newbalance.png'
import Poloralphlauren from '~/assets/images/brand-logos/poloralphlauren.png'
import Predire from '~/assets/images/brand-logos/predire.png'
import Tarte from '~/assets/images/brand-logos/tarte.png'
import Timeless from '~/assets/images/brand-logos/timeless.png'
import Tommyhilfiger from '~/assets/images/brand-logos/tommyhilfiger.png'
import Ugg from '~/assets/images/brand-logos/ugg.png'
import Uspoloassn from '~/assets/images/brand-logos/uspoloassn.png'
import Victoriassecret from '~/assets/images/brand-logos/victoriassecret.png'

export default (idEnum: typeof PjCategoryIdEnum | typeof CategoryIdEnum) => {
  return {
    [idEnum.Electronics]: [
      {
        name: ManufacturerEnum.Apple,
        img: Apple,
      },
      {
        name: ManufacturerEnum.Lenovo,
        img: Lenovo,
      },
      {
        name: ManufacturerEnum.Asus,
        img: Asus,
      },
      {
        name: ManufacturerEnum.Dell,
        img: Dell,
      },
      {
        name: ManufacturerEnum.MSI,
        img: Msi,
      },
      {
        name: ManufacturerEnum.JBL,
        img: Jbl,
      },
      // {
      //   name: 'Acer',
      //   img: Acer,
      // },
      // {
      //   name: 'HP',
      //   img: Hp,
      // },
    ],
    [idEnum.Footwear]: [
      {
        name: ManufacturerEnum.UGG,
        img: Ugg,
      },
      {
        name: ManufacturerEnum.TommyHilfiger,
        img: Tommyhilfiger,
      },
      {
        name: ManufacturerEnum.NewBalance,
        img: Newbalance,
      },
      {
        name: ManufacturerEnum.MichaelKors,
        img: Michaelkors,
      },
      {
        name: ManufacturerEnum.Columbia,
        img: Columbia,
      },
      {
        name: ManufacturerEnum.KarlLagerfeldParis,
        img: Karllagerfeld,
      },
      // {
      //   name: 'Nike',
      //   img: Nike,
      // },
      // {
      //   name: 'Timberland',
      //   img: Timberland,
      // },
    ],
    [idEnum.Clothes]: [
      {
        name: ManufacturerEnum.TommyHilfiger,
        img: Tommyhilfiger,
      },
      {
        name: ManufacturerEnum.CalvinKlein,
        img: Calvinklein,
      },
      {
        name: ManufacturerEnum.MichaelKors,
        img: Michaelkors,
      },
      {
        name: ManufacturerEnum.PoloRalphLauren,
        img: Poloralphlauren,
      },
      {
        name: ManufacturerEnum.BananaRepublic,
        img: Bananarepublic,
      },
      {
        name: ManufacturerEnum.USPoloAssn,
        img: Uspoloassn,
      },
      // {
      //   name: ManufacturerEnum.Columbia,
      //   img: Columbia,
      // },
      // {
      //   name: 'Levi's',
      //   img: Levis,
      // },
    ],
    [idEnum.Accessories]: [
      {
        name: ManufacturerEnum.COACH,
        img: Coach,
      },
      {
        name: ManufacturerEnum.MichaelKors,
        img: Michaelkors,
      },
      {
        name: ManufacturerEnum.DKNY,
        img: Dkny,
      },
      {
        name: ManufacturerEnum.TommyHilfiger,
        img: Tommyhilfiger,
      },
      {
        name: ManufacturerEnum.CalvinKlein,
        img: Calvinklein,
      },
      {
        name: ManufacturerEnum.KarlLagerfeldParis,
        img: Karllagerfeld,
      },
      // {
      //   name: 'Guess',
      //   img: Guess,
      // },
      // {
      //   name: 'U.S. Polo Assn.',
      //   img: Uspoloassn,
      // },
    ],
    [idEnum.Cosmetics]: [
      {
        name: ManufacturerEnum.Timeless,
        img: Timeless,
      },
      {
        name: ManufacturerEnum.VictoriasSecret,
        img: Victoriassecret,
      },
      {
        name: ManufacturerEnum.EsteeLauder,
        img: EsteeLauder,
      },
      {
        name: ManufacturerEnum.Crest,
        img: Crest,
      },
      {
        name: ManufacturerEnum.PredireParis,
        img: Predire,
      },
      {
        name: ManufacturerEnum.Tarte,
        img: Tarte,
      },
      // {
      //   name: 'Rhode',
      //   img: Rhode,
      // },
      // {
      //   name: 'Hempz',
      //   img: Hempz,
      // },
    ],
  } as Record<CategoryIdEnum, Array<{ name: string; img: string }>>
}
